<mat-icon
  rdPreserveSvgMaskUrl
  [svgIcon]="iconSymbol"
  [attr.aria-label]="iconSymbol"
  [class.mat-icon-rtl-mirror]="flippableIcon()">
</mat-icon>
